module.exports = __webpack_public_path__ + "static/media/stp_card_mastercard.cb38652a.png";